import { render } from "./ShowUsersOnMap.vue?vue&type=template&id=56063088&scoped=true"
import script from "./ShowUsersOnMap.vue?vue&type=script&lang=js"
export * from "./ShowUsersOnMap.vue?vue&type=script&lang=js"

import "./ShowUsersOnMap.vue?vue&type=style&index=0&id=56063088&scoped=true&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56063088"]])

export default __exports__